<template>
  <div>
    <a-card 
      size="small" 
      title="查询"
      :headStyle='{
        background : "#f3f3f3"
      }'
      >
      <a-form layout="inline">
        <a-form-item>
          <a-input placeholder="姓名" v-model:value="searchForm.username" allowClear @keyup.enter.native="searchAction()"/>
        </a-form-item>

        <a-form-item>
          <a-input placeholder="手机" v-model:value="searchForm.mobile" allowClear @keyup.enter.native="searchAction()"/>
        </a-form-item>


        <a-form-item>
          <a-button type="primary" @click='searchAction'>
            查询
          </a-button>

        </a-form-item>
        <a-form-item>
          <a-button @click="reset">重置</a-button>
        </a-form-item>
        <a-form-item>
          
        </a-form-item>
      </a-form>
    </a-card> 
    
    <a-card 
      size="small" 
      title="账户列表"
      style='margin-top:20px'
      :headStyle='{
        background : "#f3f3f3"
      }'
      :bodyStyle='{
        padding : "0"
      }'
      >
      <template v-slot:extra>
        <a-button  @click='toAdd' type="primary">添加</a-button>
      </template>

      <a-table :columns="columns" bordered 
        :data-source="list" 
        :pagination='false' 
        
        :row-key="r => r.id"
        :loading='loading'
        >

        <template v-slot:switch="{ text,record,index }">
          <a-switch :defaultChecked="record.state?true:false" @change="onChange(record,index)" />
        </template>

        
        <template v-slot:state="{ text,record }">
          {{record.state?'开启':'关闭'}}
        </template>

        <template v-slot:button="{ text,record }">
          <a-button type="primary" @click='edit(record)'>
            编辑   
          </a-button>
        </template>

        
        

      </a-table>
    </a-card> 

    <df-pagination :model='pageObj'></df-pagination>

    <a-modal v-model:visible="modalVisible" title="添加账号" @ok="handleOk">
       <!-- @ok="handleOk" -->
        <a-form layout="horizontal" :ref='setsubmitForm' :model="submitForm" :rules='rules' :label-col="labelCol" :wrapper-col="wrapperCol" >

            <a-form-item label="登陆账号" name="username">
                <a-input v-model:value="submitForm.username" placeholder="登陆账号" style='width:282px' :disabled="isedit"/>
            </a-form-item>
            <a-form-item label="登陆密码" name="password">
                <a-input v-model:value="submitForm.password" placeholder="登陆密码" style='width:282px'/>
            </a-form-item>

            <a-form-item label="手机号码" name="mobile">
                <a-input v-model:value="submitForm.mobile" placeholder="手机号码" style='width:282px' :disabled="isedit"/>
            </a-form-item>


            <a-form-item label="结束时间" name="expires" v-show='!isedit'>
                <a-date-picker
                  format="YYYY-MM-DD"
                  valueFormat='YYYY-MM-DD'
                  :disabled-date="disabledDate"
                  v-model:value="submitForm.expires"

                />
            </a-form-item>
          
        </a-form>
    </a-modal>
  </div>
</template>

<script>
  import accountApi from '@axios/account'
  import staticof from '@assets/static'
  import {  ref,reactive,provide } from "vue";
  import { useRoute, useRouter } from "vue-router";
  import { notification } from "ant-design-vue";
  import { SmileOutlined } from '@ant-design/icons-vue';
  import moment from 'moment';
  import { get } from 'http';

  export default {
    
    name: 'order',
    components: {

    },
    setup(){
      let submitFormref = ''
      const setsubmitForm = (el) =>{
          submitFormref = el;
      }

      var checkPhone = async (rule, value) => {
          if (!value) {
              return Promise.reject('手机号不能为空');
          } else {
              const reg = /^1[3|4|5|6|7|8][0-9]\d{8}$/
              if (reg.test(value)) {
                  Promise.resolve();
              } else {
                  return Promise.reject('请输入正确的手机号');
              }
          }
      };
      const router = useRouter();
      const modalVisible = ref(false);
      let submitForm = reactive({
        username : '',
        password : '',
        mobile : '', 
        expires : null
      })
      const rules =  {
          username: [
              { required: true, message: '请输入用户名', trigger: 'blur' }
          ],
          password: [
              { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          expires: [
              { required: true, message: '请输入过期时间', trigger: 'blur' }
          ],
          mobile: [
              { required: true, message: '请输入手机号码', trigger: 'blur' },
              { validator: checkPhone, trigger: 'blur' }
          ],
      };
      let loading = ref(false);
      let searchForm = reactive({
          username : '',
          mobile : '',
          
      })
      let searchParams = reactive({
          username : '',
          mobile : '',

      })

      let names = ref('')


      let  list = ref([]);

      const columns = 
        [
          {
            title: '账户',
            dataIndex: 'username',
            width: 200,
            align : 'center',
          },
          {
            title: '手机号',
            dataIndex: 'mobile',
            width: 200,
            align : 'center',
          },
          {
            title: '状态',
            dataIndex: 'state',
            width: 100,
            align : 'center',
            slots: { customRender: 'state' },
          },
          {
            title: '最后登陆时间',
            dataIndex: 'lastLoginTime',
            width: 150,
            align : 'center',
           
          },
          {
            title: '开关',
            dataIndex: 'lastLoginTime',
            width: 100,
            align : 'center',
            slots: { customRender: 'switch' },
          },
          {
            title: '操作',
            dataIndex: 'lastLoginTime',
            width: 100,
            align : 'center',
            slots: { customRender: 'button' },
          },
          


          
        ]
    
      let pageObj = ref({
          page : 1,
          rows : 10,
          totle : 1
      })

      const stateValue = ['关闭','开启']

      const searchAction = () =>{
      
        searchParams.username = searchForm.username;
        searchParams.mobile = searchForm.mobile;
   
        console.log(searchParams)
        pageObj.value = {
          page : 1,
          rows : 10,
          totle : 1
        }
        getList();
      }

      const getList = () =>{
          
          loading.value = true;
          let params = {
            username : searchParams.username?searchParams.username:null,
            mobile : searchParams.mobile?searchParams.mobile:null,
            currentPage : pageObj.value.page,
            size : pageObj.value.rows
          }
          accountApi.accountList(params).then(res => {
            loading.value = false;
            if(!res) return;
            pageObj.value.totle = res.total;
            pageObj.value.page = res.page;
            // res.data.forEach((element)=>{
            //   if(element.state){
            //     element.open = true
            //   }else{
            //     element.open = false
            //   }
            // })  
            list.value = res.data;
          })
      }

      const reset = () =>{
          searchForm.username = ''
          searchForm.mobile = ''
          searchAction()
      }
      const toLook = (row) =>{
          router.push({
            name : 'addShopIndex',
            query : {
              id : row.id,
              type : 'look'
            }
        });
      }

      const toAdd = () =>{
        submitForm.username = '';
        submitForm.password = '';
        submitForm.expires = '';
        submitForm.mobile = '';
        modalVisible.value = true;
        isedit.value = false;
      }
      const toEdit = (row) =>{
      
     

        router.push({
          name : 'addShopIndex',
          query : {
            id : row.id,
            type : 'edit'
          }
        });
      }
      const pageChange = (page) =>{
        pageObj.value.page = page;
        getList();
      }

      const onShowSizeChange = (current,pageSize) =>{
        pageObj.value.page = 1;
        pageObj.value.rows = pageSize;
        getList();
      }

      const changeBtn = (row)=> {
        let params = {
          lid : row.id,
          type : row.state==1?0:1
        }
        shopApi.switchSupplier(params).then(()=>{
          searchAction();

          notification.open({
            message: '修改成功',
            icon: <SmileOutlined  style="color: #108ee9" />,
          });

        })
      }

      const handleOk = () =>{
       
        submitFormref.validate().then(()=>{
          //添加账号
          if(isedit){
            let params = {
              id : editid,
              password : submitForm.password
            }
            accountApi.accountEdit(params).then((res)=>{
              modalVisible.value = false;
              getList();
              notification.open({
                message: '编辑成功',
                icon: <SmileOutlined  style="color: #108ee9" />,
              });
            })
          }else{
            accountApi.addAccount(submitForm).then((res)=>{
              modalVisible.value = false;
              getList();
              notification.open({
                message: '添加成功',
                icon: <SmileOutlined  style="color: #108ee9" />,
              });
            })
          }
          


        }).catch(err => {
          console.log(err)
        })
      }
      
      
      // let submitForm = reactive({
      //   username : '',
      //   password : '',
      //   mobile : '', 
      //   expires : null
      // })

      let isedit = ref(false);
      let editid = '';
      const edit = (row) => {
        if(submitFormref) submitFormref.resetFields();
        editid = row.id;
        isedit.value = true;
        modalVisible.value = true;
        submitForm.username = row.username;
        submitForm.mobile = row.mobile;
        submitForm.expires = '1970-01-01';
        submitForm.password = '';
      }

      const onChange = (row,index) => {

        accountApi.switchState(row.id).then(()=>{
          notification.open({
            message: '修改成功',
            icon: <SmileOutlined  style="color: #108ee9" />,
          });
          getList();
        }).catch(()=>{
          notification.open({
            message: '修改失败',
            icon: <SmileOutlined  style="color: #108ee9" />,
          });
          getList();
        })
      }

      provide('pageChange',pageChange);
      provide('onShowSizeChange',onShowSizeChange);

     

      getList();

      return {
        onChange,
        isedit,
        edit,
        names,
        // data
        staticof,
        loading,
        searchForm,
        searchParams,
        list,
        columns,
        pageObj,
        stateValue,
        //methods
        searchAction,
        reset,
        toLook,
        toAdd,
        toEdit,
        modalVisible,
        moment,
        disabledDate(current) {
          // Can not select days before today and today

          return current && current < moment().endOf('day') ;
        },
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
        rules,
        submitForm,
        handleOk,
        setsubmitForm,

      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .table_logo{
      width: 70px;
      
  }
</style>



